// extracted by mini-css-extract-plugin
module.exports = {"btns":"purchaseDrawer_btns__1Vmz6"};